import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllMainCharacters from "../../Components/Admin/AdminAllMainCharacters";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllMainCharactersPage = () => {
  return (
    <AdminAllMainCharacters />
  );
};

export default AdminAllMainCharactersPage;
